import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { Server } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { getStoredFunMode, translate } from '../i18n';

export const kubernetesOverviewRouteRef = createRouteRef();

/**
 * The clusters overview page at `/kubernetes`. Extension id:
 * `page:k8s-overview`. It replaces the kubernetes plugin's stock
 * `page:kubernetes` (disabled in app-config — it shares the path but only
 * renders entity content); the title/icon/routeRef outputs surface it as the
 * rail's Kubernetes item (taken explicitly in modules/nav/Sidebar.tsx).
 */
export const kubernetesOverviewPage = PageBlueprint.make({
  params: {
    path: '/kubernetes',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('kubernetes.page.title', getStoredFunMode()),
    // Lucide Server, matching the rail's own glyph set (Boxes is taken by
    // Catalog).
    icon: <Server size={20} strokeWidth={1.75} />,
    routeRef: kubernetesOverviewRouteRef,
    // The page renders its own kit-style header row; skip the PageLayout one.
    noHeader: true,
    loader: () =>
      import('./KubernetesOverviewPage').then(m => (
        <PageShareTitle title="Kubernetes">
          <m.KubernetesOverviewPage />
        </PageShareTitle>
      )),
  },
});

export const kubernetesOverviewPlugin = createFrontendPlugin({
  pluginId: 'k8s-overview',
  extensions: [kubernetesOverviewPage],
});
